import React from 'react';
import ReactDOM from 'react-dom';
import App from './apps/main';

ReactDOM.render(<App />, document.getElementById('root'));
